export const BATCH_APPROVAL_TEST_ID: string = "batch-approval";

export const BATCH_APPROVAL_ACK_ALL_TEST_ID: string = "batch-approval-ack-all";

export const BATCH_APPROVAL_APPLY_ALL_TEST_ID: string =
  "batch-approval-apply-all";

export const BATCH_TRACK_SECTION_TEST_ID = (track: string): string =>
  `batch-track-section-${track}`;
